import { useFeatures } from '@shared/feature-flags';

/**
 * Hook to check if the Market Share Report feature is enabled.
 * This combines the feature flag check with any additional business logic if needed.
 * 
 * @returns {boolean} true if the market share report feature is enabled
 */
export const useMarketShareReportFeature = (): boolean => {
  const { getFeature } = useFeatures();
  return getFeature('marketShareReport');
};
